import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FirstErrorPipe } from '@fuse/pipes/first-error/first-error.pipe';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

@Component({
  selector: 'fc-time-input',
  templateUrl: './fc-time-input.component.html',
  styleUrls: ['./fc-time-input.component.scss']
})
export class FcTimeInputComponent implements OnInit, OnDestroy {
  @Input()
  public control: FormControl;

  @Input()
  public label: string;

  @Input()
  public translateErrorPrefix: string;

  @Input()
  public required: boolean;

  @Input()
  public fixedColor = true;

  @Input()
  public hasGroupError: boolean;

  @Input()
  public hasCustomErrors = false;

  @Input()
  public showLabel = true;

  @Input()
  public showIcon = true;

  @Input()
  public placeholder = '';

  @Input()
  public textCentered = false;


  public errorMessage: string;
  public timeValueIsValid: boolean;
  public colorTimeIcon = false;

  private readonly removeSubscriptions = new Subject<void>();

  constructor(
    private firstErrorPipe: FirstErrorPipe,
    private fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  public ngOnInit(): void {
    this.updateControlState();

    this.control.valueChanges.pipe(
      takeUntil(this.removeSubscriptions)
    ).subscribe(() => {
      this.updateControlState();
      this.errorMessage = this.firstErrorPipe.transform(this.control);
    });
  }

  public ngOnDestroy(): void {
    this.removeSubscriptions.next();
    this.removeSubscriptions.complete();
  }

  public updateControlState(): void {
    if (this.control.disabled) {
      return;
    }

    const convertedTime = moment(this.control.value, 'HH:mm:ss');
    this.timeValueIsValid = this.control.valid && this.control.value && this.control.value.length >= 4 && convertedTime.isValid();
    this.colorTimeIcon = this.timeValueIsValid || this.fixedColor;

    if (this.timeValueIsValid) {
      this.control.setValue(convertedTime.format('HH:mm:ss'), { emitEvent: false });
    } else if (this.control.value && this.control.value.length) {
      this.control.setErrors({
        INVALID_TIME: true
      });
    } else {
      this.control.setValue(null, { emitEvent: false });
    }
  }
}
